export default function Terms() {
  return (
    <div className="min-h-screen bg-black py-16 px-4" dir="rtl">
      <div className="max-w-4xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">شروط الخدمة وسياسة الإرجاع</h1>
        <div className="space-y-6 text-neutral-300 leading-loose text-lg">
          <h2 className="text-2xl font-bold text-white">الشروط العامة</h2>
          <p>
            باستخدامك لموقع برولاكس، فإنك توافق على الشروط التالية. إذا كنت لا توافق على أي
            من هذه البنود، يرجى عدم استخدام الموقع.
          </p>
          <p>
            <strong className="text-white">الطلبات والدفع</strong><br />
            جميع الأسعار بالشيكل وتشمل ضريبة القيمة المضافة. نتيح الدفع عند الاستلام فقط، دون
            الحاجة لبطاقة ائتمان. بمجرد تقديم الطلب، يعتبر ملزماً ما لم يتم إلغاؤه قبل الشحن.
          </p>

          <h2 className="text-2xl font-bold text-white">سياسة الإرجاع والاستبدال</h2>
          <p>
            يمكنك إرجاع أي منتج خلال <strong className="text-red-500">14 يوماً</strong> من تاريخ
            استلامه، بشرط أن يكون:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>في حالته الأصلية (غير مستخدم، غير مفتوح).</li>
            <li>بالتغليف الأصلي وكامل الملحقات.</li>
            <li>مرفقاً بفاتورة الشراء أو رقم الطلب.</li>
          </ul>
          <p>
            يتم استرداد المبلغ عبر نفس طريقة الدفع (نقداً عند الاستلام) بعد فحص المنتج. في حالة
            استلام منتج تالف أو معيب، نتحمل تكاليف الإرجاع ونقوم باستبداله أو إعادة المبلغ
            بالكامل.
          </p>
          <p>
            للإرجاع، يرجى التواصل مع خدمة العملاء لتنسيق عملية الاستلام.
          </p>

          <h2 className="text-2xl font-bold text-white">الملكية الفكرية</h2>
          <p>
            جميع المحتويات على هذا الموقع (نصوص، صور، شعارات) هي ملك لبرولاكس ولا يجوز
            استخدامها دون إذن.
          </p>
        </div>
      </div>
    </div>
  );
}